var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{key:_vm.possibleLangPrefix,staticClass:"uppercase text-gray-200 font-bold tracking-[3px] text-sm do-not-translate leading-none",attrs:{"href":("" + _vm.possibleLangPrefix)}},[_vm._v("\n    Pure "),_c('br'),_vm._v("\n    Pascale\n")])}
var staticRenderFns = []

export { render, staticRenderFns }